unit unit_AuftragSuche;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Connection, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Vcl.Grids, WEBLib.DBCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, strutils,
  VCL.TMSFNCCustomControl, VCL.TMSFNCTableView, WEBLib.Grids, WEBLib.Buttons, DB;

type
  TfrmAuftragSuche = class(TForm)
    DataSet: TXDataWebDataSet;
    Source: TDataSource;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    TC: TTableControl;
    btnzurueck: TButton;
    edtSuchbegriff: TEdit;
    ResultLabel: TLabel;
    DataSetNummerkomplett: TStringField;
    DataSetKundennummerKundennummer: TStringField;
    DataSetDatum: TDateTimeField;
    DataSetAuftragsbezeichnung: TStringField;
    DataSetNachname: TStringField;
    DataSetVorname: TStringField;
    WebTimer1: TTimer;
    procedure WebFormShow(Sender: TObject);
    procedure DataSetAfterOpen(DataSet: TDataSet);
    procedure btnzurueckClick(Sender: TObject);
    procedure edtSuchbegriffChange(Sender: TObject);
    procedure WebTimer1Timer(Sender: TObject);

    public
    Auftragnummer:string;
    LUNachname:string;
    LUVorname:string;
    LUAuftragsbezeichnung:string;
    buttonAuftragnummer:TButton;
    procedure buttonAuftragnummerclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  frmAuftragSuche: TfrmAuftragSuche;

implementation
  uses unit1, unit2;
{$R *.dfm}


procedure TfrmAuftragSuche.btnzurueckClick(Sender: TObject);
begin
  self.Close;
end;

procedure TfrmAuftragSuche.buttonauftragnummerclick(Sender:TObject);
begin
  Auftragnummer:=(sender as TButton).Caption;
  dataset.Locate('Nummerkomplett',Auftragnummer,[]);
  LUNachname:=DataSetNachname.AsString;
  LUVorname:=DataSetVorname.AsString;
  LUAuftragsbezeichnung:=DataSetAuftragsbezeichnung.AsString;
  self.Close;
end;

procedure TfrmAuftragSuche.DataSetAfterOpen(DataSet: TDataSet);
var
  i:integer;
  myelement:TJSHTMLElement;
begin
  myelement:=container3.ElementHandle;
  tc.ParentElement:=myelement;
  i:=0;
  TC.visible:=true;
  TC.ColCount:=4;
  tc.RowCount:=dataset.RecordCount+1;
  tc.Cells[0,i]:='<b>Nummerkomplett';
  tc.Cells[1,i]:='<b>Datum';
  tc.Cells[2,i]:='<b>Auftragsbezeichnung';
  tc.Cells[3,i]:='<b>Kunde';
  dataset.First;
  if dataset.RecordCount=0 then resultlabel.Caption:='nichts gefunden';
  if dataset.RecordCount>0 then resultlabel.Caption:='Übereinstimmungen: '+inttostr(dataset.RecordCount);
  if dataset.RecordCount>20 then resultlabel.Caption:='mehr als 20 Übereinstimmungen';
  tc.BeginUpdate;
  while not dataset.eof do
  begin
    inc(i);
    myelement:=TC.cellelements[0,i];
    myelement.innerHTML:='';
    buttonauftragnummer:=TButton.Create(self);
    buttonauftragnummer.ElementClassName:='btn btn-sm btn-info';
    buttonauftragnummer.HeightStyle:=ssauto;
    buttonauftragnummer.Width:=150;
    buttonauftragnummer.tag:=0;
    buttonauftragnummer.Caption:=DataSetNummerkomplett.AsString;
    buttonauftragnummer.OnClick:=@buttonauftragnummerClick;
    buttonauftragnummer.ParentElement:=myelement;
    TC.Cells[1,i]:=formatdatetime('DD.MM.YYYY',DataSetDatum.Asdatetime);
    TC.Cells[2,i]:=DataSetAuftragsbezeichnung.AsString;
    TC.Cells[3,i]:=trim(DataSetVorname.AsString+' '+DataSetNachname.AsString)+' ('+DataSetKundennummerKundennummer.AsString+')';
    dataset.Next;
  end;
  Tc.EndUpdate;
end;



procedure TfrmAuftragSuche.edtSuchbegriffChange(Sender: TObject);
var
  suchtextkontakt:string;
begin
  suchtextkontakt:=edtsuchbegriff.Text;
  if length(suchtextkontakt)>0 then
  begin
    dataset.Close;
    dataset.QueryString:='$expand=Kundennummer&$filter=(Auftragerledigt eq 0) AND (contains(Nummerkomplett, '''+edtsuchbegriff.Text+''') OR contains(Kundennummer, '''+edtsuchbegriff.Text+''') OR contains(Auftragsbezeichnung, '''+edtsuchbegriff.Text+'''))&$orderby=Nummerkomplett DESC';
    dataset.Load;
  end;

end;

procedure TfrmAuftragSuche.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Auftrag-Suche</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  container2.ParentElement:=myelement;
  Container3.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  resultlabel.Caption:='Suchbegriff';
  resultlabel.ParentElement:=myelement;
  edtsuchbegriff.ParentElement:=myelement;
  TC.Visible:=false;
  Auftragnummer:='';
  edtsuchbegriff.SetFocus;
  if PZE_AutoAuftragnummer<>'' then
  begin
    edtsuchbegriff.Text:=PZE_AutoAuftragnummer;
    edtsuchbegriffChange(sender);
    PZE_AutoAuftragnummer:='';
  end;
end;

procedure TfrmAuftragSuche.WebTimer1Timer(Sender: TObject);
begin
  WebTimer1.Enabled:=false;
  self.Close;
end;

procedure TfrmAuftragSuche.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ResultLabel := TLabel.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  TC := TTableControl.Create(Self);
  btnzurueck := TButton.Create(Self);
  edtSuchbegriff := TEdit.Create(Self);
  DataSet := TXDataWebDataSet.Create(Self);
  DataSetNummerkomplett := TStringField.Create(Self);
  DataSetDatum := TDateTimeField.Create(Self);
  DataSetAuftragsbezeichnung := TStringField.Create(Self);
  DataSetKundennummerKundennummer := TStringField.Create(Self);
  DataSetNachname := TStringField.Create(Self);
  DataSetVorname := TStringField.Create(Self);
  Source := TDataSource.Create(Self);
  WebTimer1 := TTimer.Create(Self);

  ResultLabel.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  TC.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  edtSuchbegriff.BeforeLoadDFMValues;
  DataSet.BeforeLoadDFMValues;
  DataSetNummerkomplett.BeforeLoadDFMValues;
  DataSetDatum.BeforeLoadDFMValues;
  DataSetAuftragsbezeichnung.BeforeLoadDFMValues;
  DataSetKundennummerKundennummer.BeforeLoadDFMValues;
  DataSetNachname.BeforeLoadDFMValues;
  DataSetVorname.BeforeLoadDFMValues;
  Source.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  try
    Name := 'frmAuftragSuche';
    Width := 223;
    Height := 376;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    ResultLabel.SetParentComponent(Self);
    ResultLabel.Name := 'ResultLabel';
    ResultLabel.Left := 114;
    ResultLabel.Top := 231;
    ResultLabel.Width := 55;
    ResultLabel.Height := 13;
    ResultLabel.Caption := 'ResultLabel';
    ResultLabel.ElementClassName := 'h6 m-2';
    ResultLabel.ElementFont := efCSS;
    ResultLabel.ElementPosition := epIgnore;
    ResultLabel.HeightStyle := ssAuto;
    ResultLabel.HeightPercent := 100.000000000000000000;
    ResultLabel.WidthStyle := ssPercent;
    ResultLabel.WidthPercent := 100.000000000000000000;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1 border border-info';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 2;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 141;
    TC.Width := 169;
    TC.Height := 79;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 3;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.ColCount := 1;
    TC.RowCount := 5;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 226;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    edtSuchbegriff.SetParentComponent(Self);
    edtSuchbegriff.Name := 'edtSuchbegriff';
    edtSuchbegriff.Left := 8;
    edtSuchbegriff.Top := 296;
    edtSuchbegriff.Width := 150;
    edtSuchbegriff.Height := 22;
    edtSuchbegriff.ChildOrder := 6;
    edtSuchbegriff.ElementClassName := 'form-control input-sm m-1';
    edtSuchbegriff.ElementFont := efCSS;
    edtSuchbegriff.ElementPosition := epIgnore;
    edtSuchbegriff.HeightStyle := ssAuto;
    edtSuchbegriff.HeightPercent := 100.000000000000000000;
    edtSuchbegriff.ShowHint := True;
    edtSuchbegriff.TextHint := 'Suchbegriff eingeben';
    edtSuchbegriff.WidthPercent := 60.000000000000000000;
    SetEvent(edtSuchbegriff, Self, 'OnChange', 'edtSuchbegriffChange');
    DataSet.SetParentComponent(Self);
    DataSet.Name := 'DataSet';
    DataSet.AfterOpen := DataSetAfterOpen;
    DataSet.EntitySetName := 'Auftrag';
    DataSet.Connection := DM2.XDataWebConnection1;
    DataSet.SubpropsDepth := 1;
    DataSet.QueryString := '$expand=Kundennummer&$filter=(Auftragerledigt eq 0)&$orderby=Nummerkomplett DESC';
    DataSet.QueryTop := 20;
    DataSet.Left := 8;
    DataSet.Top := 56;
    DataSetNummerkomplett.SetParentComponent(DataSet);
    DataSetNummerkomplett.Name := 'DataSetNummerkomplett';
    DataSetNummerkomplett.FieldName := 'Nummerkomplett';
    DataSetNummerkomplett.Required := True;
    DataSetNummerkomplett.Size := 10;
    DataSetDatum.SetParentComponent(DataSet);
    DataSetDatum.Name := 'DataSetDatum';
    DataSetDatum.FieldName := 'Datum';
    DataSetDatum.Required := True;
    DataSetAuftragsbezeichnung.SetParentComponent(DataSet);
    DataSetAuftragsbezeichnung.Name := 'DataSetAuftragsbezeichnung';
    DataSetAuftragsbezeichnung.FieldName := 'Auftragsbezeichnung';
    DataSetAuftragsbezeichnung.Size := 255;
    DataSetKundennummerKundennummer.SetParentComponent(DataSet);
    DataSetKundennummerKundennummer.Name := 'DataSetKundennummerKundennummer';
    DataSetKundennummerKundennummer.FieldName := 'Kundennummer.Kundennummer';
    DataSetKundennummerKundennummer.Size := 13;
    DataSetNachname.SetParentComponent(DataSet);
    DataSetNachname.Name := 'DataSetNachname';
    DataSetNachname.FieldName := 'Nachname';
    DataSetNachname.Size := 50;
    DataSetVorname.SetParentComponent(DataSet);
    DataSetVorname.Name := 'DataSetVorname';
    DataSetVorname.FieldName := 'Vorname';
    DataSetVorname.Size := 50;
    Source.SetParentComponent(Self);
    Source.Name := 'Source';
    Source.DataSet := DataSet;
    Source.Left := 56;
    Source.Top := 56;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Interval := 13000;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 152;
    WebTimer1.Top := 256;
  finally
    ResultLabel.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    TC.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    edtSuchbegriff.AfterLoadDFMValues;
    DataSet.AfterLoadDFMValues;
    DataSetNummerkomplett.AfterLoadDFMValues;
    DataSetDatum.AfterLoadDFMValues;
    DataSetAuftragsbezeichnung.AfterLoadDFMValues;
    DataSetKundennummerKundennummer.AfterLoadDFMValues;
    DataSetNachname.AfterLoadDFMValues;
    DataSetVorname.AfterLoadDFMValues;
    Source.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
  end;
end;

end.
